import { memo } from 'react'

const SVGSprite = () => {
  return (
    <svg style={{ display: 'none' }}>
      <symbol id="ico-close" viewBox="0 0 20 20">
        <path d="M20 1.42L18.58 0 10 8.58 1.42 0 0 1.42 8.58 10 0 18.58 1.42 20 10 11.42 18.58 20 20 18.58 11.42 10z" />
      </symbol>
      <symbol id="ico-arrow-left" viewBox="0 0 24.22 45.88">
        <path d="M0 22.94l1.69 1.94 18 21L24.22 42 7.88 22.94 24.22 3.88 19.69 0l-18 21z" />
      </symbol>
      <symbol id="ico-arrow-right" viewBox="0 0 5.952 9.819">
        <path d="M3.564 4.904L0 8.619l1.251 1.2 4.7-4.916-4.7-4.9L0 1.203z" />
      </symbol>
      <symbol id="ico-arrow-right-triangular" viewBox="0 0 24 24">
        <path d="M21 12L3 24V0z" />
      </symbol>
      <symbol id="ico-play" viewBox="0 0 31.5 36.37">
        <path d="M30.5 18.19l-15 8.66-15 8.66V.87l15 8.66 15 8.66z" />
      </symbol>
      <symbol id="ico-fullscreen" viewBox="0 0 17 17">
        <path d="M0 7V0h7v2H2v5zm10-7h7v7h-2V2h-5zm7 10v7h-7v-2h5v-5zM7 17H0v-7h2v5h5z" />
      </symbol>
      <symbol id="ico-arrow" viewBox="0 0 53.75 26.5">
        <path d="M52.25 12.25H5.49l9.69-9.69A1.5 1.5 0 1013.06.44L0 13.5l12.56 12.56a1.5 1.5 0 002.12 0 1.49 1.49 0 000-2.12L6 15.25h46.25a1.5 1.5 0 000-3z" />
      </symbol>
      <symbol id="ico-facebook" viewBox="0 0 50 50">
        <path d="M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0Zm5.36,25H26.85V37.5H21.66V25H19.19V20.6h2.47V17.74c0-2,1-5.24,5.24-5.24l3.85,0V16.8H28a1.06,1.06,0,0,0-1.1,1.2v2.6h4Z" />
      </symbol>
      <symbol id="ico-linkedin" viewBox="0 0 551.2 551.2">
        <path d="M148.8 210h35v175h-35V210zM148.8 131.2h35v35h-35v-35zM271.2 319.4v-21.9c0-26.7 21.4-48.1 48.1-48.1s48.1 21.4 48.1 48.1V385h35v-87.5c0-45.9-37.2-83.1-83.1-83.1-17.9 0-34.6 5.7-48.1 15.3V210h-35v175h35v-65.6z" />
        <path d="M551.2 0H0v551.2h551.2V0zm-35 516.2H35V35h481.2v481.2z" />
      </symbol>
      <symbol id="ico-pinterest" viewBox="0 0 50 50">
        <path d="M25 0a25 25 0 1025 25A25 25 0 0025 0zm2.58 30.57a4.13 4.13 0 01-3.51-1.79s-.83 3.31-1 3.94a15.23 15.23 0 01-2.59 4.7.19.19 0 01-.34-.08 16 16 0 010-5.46c.28-1.16 1.85-7.82 1.85-7.82a5.52 5.52 0 01-.46-2.27c0-2.13 1.24-3.72 2.77-3.72a1.92 1.92 0 011.94 2.16c0 1.31-.84 3.27-1.27 5.09a2.22 2.22 0 002.27 2.77c2.72 0 4.55-3.5 4.55-7.64 0-3.14-2.12-5.5-6-5.5a6.81 6.81 0 00-7.07 6.88 4.11 4.11 0 00.95 2.81.72.72 0 01.21.81c-.07.26-.23.9-.29 1.15a.5.5 0 01-.72.36c-2-.82-2.94-3-2.94-5.49 0-4.08 3.44-9 10.26-9 5.48 0 9.09 4 9.09 8.23.05 5.66-3.08 9.87-7.7 9.87z" />
      </symbol>
      <symbol id="ico-twitter" viewBox="0 0 50 50">
        <path d="M25 0a25 25 0 1025 25A25 25 0 0025 0zm9.94 19.9v.67A14.6 14.6 0 0112.5 32.86c.4 0 .81.07 1.22.07a10.24 10.24 0 006.37-2.2 5.13 5.13 0 01-4.79-3.56 5.23 5.23 0 001 .09 5 5 0 001.35-.18 5.13 5.13 0 01-4.12-5V22a5.26 5.26 0 002.33.64 5.15 5.15 0 01-1.59-6.85 14.56 14.56 0 0010.57 5.36 5.67 5.67 0 01-.16-1.15 5.13 5.13 0 018.87-3.51 10.2 10.2 0 003.26-1.24 5.12 5.12 0 01-2.25 2.83 10.4 10.4 0 002.94-.8 10.41 10.41 0 01-2.56 2.62z" />
      </symbol>
      <symbol id="ico-email" viewBox="0 0 30 30">
        <path d="M3.08 5.45a3.14 3.14 0 00-2.27.81A3.15 3.15 0 000 8.52v13a3.12 3.12 0 00.82 2.26 3.18 3.18 0 002.28.81h23.84a3.14 3.14 0 002.26-.82 3.17 3.17 0 00.8-2.28v-13a3.1 3.1 0 00-.81-2.24 3.1 3.1 0 00-2.19-.8zm.33 2.05h23.18l-11.08 9a1 1 0 01-1 0zM2.05 9l7.34 6-7.34 6.22zM28 9v12.2L20.61 15zm-17 7.28c.85.64 1.67 1.42 2.53 2a3.35 3.35 0 003 0c.86-.61 1.69-1.34 2.53-2l7.3 6.22H3.69z" />
      </symbol>
      <symbol id="ico-telephone" viewBox="0 0 30 30">
        <path d="M5.36 3c1.9-1.47 3.54-1.21 4.32.52 1.56 3.11 2.68 4.67 1.56 5.88-2.08 1.39-3.55 2.08-2.77 3.6a18.17 18.17 0 008.22 8.83c1.39.86 2.17-.61 3.72-2.51 1.3-1 2.77.08 5.8 1.9 1.64.95 1.73 2.51.17 4.33C17.3 35.71-5.46 11.39 5.36 3z" />
      </symbol>
      <symbol id="ico-mouse" viewBox="0 0 14 22">
        <rect id="rectangle" strokeWidth="2" fillRule="nonzero" x="1" y="1" width="12" height="20" rx="6" />
        <circle id="wheel" strokeWidth="2" fillRule="nonzero" cx="7" cy="7" r="1" />
      </symbol>
      {/* Hume Custom Icon */}
      <svg id="ico-logo" viewBox="0 0 240 240">
        <path d="M205.6,154.4c-24,52-77.8,56.5-93.3,56.5c-17.4,0-75-1.8-75-77.3c0-66,55.6-103.4,90.6-103.4 c30.6,0,57,13.8,57,46.7s-41.7,52-65.2,52c-20.5,0-35.4-4.7-35.4-4.7" />
      </svg>
      <symbol id="ico-question-mark" viewBox="0 0 102 161">
        <linearGradient id="a" x1=".5" x2=".5" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#f08c6f" />
          <stop offset=".517" stopColor="#eaad8b" />
          <stop offset="1" stopColor="#da716e" />
        </linearGradient>
        <path data-name="Tracciato 19" d="M53.324 4.317h30.258v-28.211H58.329c-2.5 0-4.1-1.138-4.1-2.73 0-9.555 53.464 2.5 53.464-40.5 0-24.571-21.386-40.5-50.506-40.5-30.941 0-51.644 18.883-51.871 47.776h33.9c.228-11.6 6.6-18.656 17.973-18.656 8.873 0 14.788 3.64 14.788 9.328 0 16.835-53.691 2.5-53.691 44.364.002 18.436 14.562 29.129 35.038 29.129ZM39.446 15.92v37.538h40.5V15.92Z" transform="translate(-5.32 107.616)" fill="url(#a)" />
      </symbol>
      <symbol id="ico-asterisk" viewBox="0 0 175 168.4">
        <linearGradient id="g1" y1="1">
          <stop stopColor="#f08c6f" />
          <stop offset=".47" stopColor="#eaad8b" />
          <stop offset="1" stopColor="#da716e" />
        </linearGradient>
        <path id="a" d="m57.3 168.4 30.2-42.8 30.2 42.8 38.9-28.4-29.7-42L175 81.8l-14.9-45.9-48.5 16.2V0H63.4v52.1L15.3 35.9 0 81.8 48.6 98l-30.2 42z" fill="url(#g1)" />
      </symbol>
      <symbol id="ico-hashtag" width="205.879" height="222.744">
        <path data-name="Tracciato 25" d="M24.184 222.744h38.821l12.728-58.232h32.457l-12.728 58.232h38.5l12.41-58.232h46.458v-37.548h-38.5l7-31.184h44.549V58.232h-36.912L181.695 0h-38.821l-12.728 58.232h-31.82L110.736 0H71.912L59.504 58.232H13.365V95.78h38.5l-7 31.184H0v37.548h37.23Zm59.5-95.78L90.37 95.78h32.457l-7.315 31.184Z" fill="#fff" />
      </symbol>
    </svg>
  )
}

export default memo(SVGSprite)
